export default "__VITE_ASSET___NzwdJti__"